export default [
  {
    path: 'repositorio',
    name: 'document-management',
    meta: { permiso: 'ED060', requiereLogin: true },
    component: () => import('@/febos/global/documentManagement/vistas/DocumentManagement')
  },
  {
    path: 'repositorio/buscar',
    name: 'repository-search',
    meta: { permiso: 'ED060', requiereLogin: true },
    component: () => import('@/febos/global/documentManagement/vistas/RepositorySearch')
  },
  {
    path: 'kanban/archivos/:id/actividades',
    name: 'repository-file-activities',
    meta: { permiso: '*', requiereLogin: true }, // TODO: set permission
    component: () => import('@/febos/global/kanban/FileActivityBoard')
  },
  {
    path: 'kanban/carpetas/:id/actividades',
    name: 'repository-folder-activities',
    meta: { permiso: '*', requiereLogin: true }, // TODO: set permission
    component: () => import('@/febos/global/kanban/FolderActivityBoard')
  },
  {
    path: 'repositorio/:wizard/:id?',
    params: { codeType: '' },
    name: 'manage-doc-wizard-update',
    query: { codeType: '' },
    meta: { permiso: '*', requiereLogin: true }, // TODO: set permission
    component: () => import('@/febos/chile/approvals/wizardFlow/FileWizard')
  },
  {
    path: 'repositorio/documento/nuevo/:type',
    name: 'create-custom-document',
    meta: { permiso: '*', requiereLogin: true }, // TODO: set permission
    component: () => import('@/febos/global/customDocuments/vistas/CreateDocument')
  },
  {
    path: 'form/repositorio/documento/nuevo/:type',
    name: 'edit-custom-document',
    meta: { permiso: '*', requiereLogin: true }, // TODO: set permission
    component: () => import('@/febos/global/customDocuments/vistas/CreateDocument')
  },

  {
    path: 'rules/:type/:repositoryId/:folderId/:ruleId',
    params: { },
    name: 'configure-rules-event',
    query: { },
    meta: { permiso: '*', requiereLogin: true },
    component: () => import('@/febos/global/rules/Rule')
  },
  {
    path: 'rules/:type/:repositoryId/:folderId',
    params: { },
    name: 'list-rules-events',
    query: { },
    meta: { permiso: '*', requiereLogin: true },
    component: () => import('@/febos/global/rules/Rules')
  },
];
